//import Vue from 'vue'
import axios from 'axios'
import store from '../store'
import { showGlobalToast } from '@/utils/toast'

let juniperAPI = axios.create({
	baseURL: process.env.VUE_APP_JUNIPER_API,
	// withCredentials: true,
	// timeout: 1000,
	headers: {
		//'access-control-request-headers':	'link, x-total',
		//'X-Custom-Header': 'foobar',
	},
	params: {
		//serviceToken: '4f29d14b-70b8-4ce2-9bcc-12497ecfcdec'
	},
})

juniperAPI.interceptors.request.use(request => {
	// request.headers.common['Accept'] = 'application/json'
	// request.headers.common['Content-type'] = 'application/json'
	request.headers['mc2-auth'] = `${store.state.juniperApiToken}`

	// Send mc2-user header for MC2 authentication bypass
	// if (store.state.authUser && store.state.authUser.email) {
	// 	request.headers['mc2-user'] = store.state.authUser.email
	// }

	if (store.state.tokenJuniper) {
		request.headers['Authorization'] = `Bearer ${store.state.tokenJuniper}`
	}

	return request
})

juniperAPI.interceptors.response.use(
	response => {
		// Globally surface "no changes to push" outcomes from any
		// /static/generate-style endpoint. The backend returns 200 with
		// `no_changes: true` whenever a git-deployed client produces no
		// diff; rather than thread this flag through every component
		// individually (15+ call sites), we display a uniform toast here.
		// Components that want to suppress their own follow-up success
		// notification can still check `response.data.no_changes`.
		if (response && response.data && response.data.no_changes) {
			showGlobalToast(
				response.data.message || 'There are no changes to push',
				'info'
			)
		}
		return response
	},
	error => {
		// Return non auth error
		if (error.response.status !== 401) {
			return new Promise((resolve, reject) => {
				reject(error)
			})
		}

		// Modal
		// Store error

		return store
			.dispatch('authLoginJuniper', { login: store.state.authUser.email })
			.then(() => {
				// Make new request with all required headers
				const config = error.config
				config.headers = {
					Authorization: `Bearer ${store.state.tokenJuniper}`,
					'mc2-auth': `${store.state.juniperApiToken}`,
					Accept: 'application/json, text/plain, */*',
					'Content-Type': 'application/json',
				}
				if (store.state.authUser && store.state.authUser.email) {
					config.headers['mc2-user'] = store.state.authUser.email
				}

				return new Promise((resolve, reject) => {
					axios
						.request(config)
						.then(response => {
							resolve(response)
						})
						.catch(error => {
							reject(error)
						})
				})
			})
			.catch(error => {
				Promise.reject(error)
			})
	}
)

export default juniperAPI
